import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpdateStory = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 184,
	height: 184,
	viewBox: "0 0 184 184",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			opacity: .1,
			cx: 92,
			cy: 92,
			r: 91.8494,
			fill: "url(#paint0_radial_16390_68019)",
			fillOpacity: .2,
			stroke: "#561090",
			strokeWidth: .301149
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M155.849 92C155.849 127.816 127.038 156.849 91.5 156.849C55.9619 156.849 27.1506 127.816 27.1506 92C27.1506 56.1836 55.9619 27.1506 91.5 27.1506C127.038 27.1506 155.849 56.1836 155.849 92Z",
			fill: "url(#paint1_radial_16390_68019)",
			fillOpacity: .4,
			stroke: "#561090",
			strokeWidth: .301149
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_bddi_16390_68019)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 92.25,
				cy: 92.25,
				r: 38.25,
				fill: "white",
				fillOpacity: .8,
				shapeRendering: "crispEdges"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.428 96.7059L99.0714 94.3492L101.428 91.9925C102.047 91.3734 102.538 90.6385 102.873 89.8296C103.208 89.0208 103.381 88.1539 103.381 87.2784C103.381 86.4029 103.208 85.5359 102.873 84.7271C102.538 83.9182 102.047 83.1833 101.428 82.5642C100.809 81.9451 100.074 81.454 99.2652 81.119C98.4564 80.784 97.5894 80.6115 96.7139 80.6115C95.8384 80.6115 94.9715 80.784 94.1627 81.119C93.3538 81.454 92.6189 81.9451 91.9998 82.5642L89.6431 84.9209L87.2864 82.5642L89.6431 80.2075C91.5236 78.3574 94.059 77.3253 96.6971 77.336C99.3351 77.3468 101.862 78.3995 103.727 80.2649C105.593 82.1303 106.646 84.6572 106.656 87.2952C106.667 89.9333 105.635 92.4687 103.785 94.3492L101.428 96.7059ZM96.7131 101.421L94.3564 103.778C93.4306 104.719 92.3277 105.467 91.1112 105.98C89.8947 106.492 88.5888 106.759 87.2687 106.764C85.9487 106.77 84.6406 106.514 83.42 106.011C82.1994 105.508 81.0904 104.769 80.157 103.835C79.2235 102.902 78.4841 101.793 77.9815 100.572C77.4788 99.3517 77.2227 98.0436 77.2281 96.7236C77.2335 95.4035 77.5002 94.0976 78.0128 92.8811C78.5254 91.6646 79.2738 90.5617 80.2148 89.6359L82.5714 87.2792L84.9281 89.6359L82.5714 91.9925C81.9524 92.6116 81.4613 93.3465 81.1263 94.1554C80.7912 94.9643 80.6188 95.8312 80.6188 96.7067C80.6188 97.5822 80.7912 98.4491 81.1263 99.258C81.4613 100.067 81.9524 100.802 82.5714 101.421C83.1905 102.04 83.9255 102.531 84.7343 102.866C85.5432 103.201 86.4101 103.374 87.2856 103.374C88.1611 103.374 89.028 103.201 89.8369 102.866C90.6458 102.531 91.3807 102.04 91.9998 101.421L94.3564 99.0642L96.7131 101.421ZM96.7131 84.9209L99.0714 87.2792L87.2864 99.0625L84.9281 96.7059L96.7131 84.9225V84.9209Z",
			fill: "#7106EE"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_bddi_16390_68019",
				x: 26,
				y: 44,
				width: 132.5,
				height: 132.5,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 2.5
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_16390_68019"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_16390_68019",
						result: "effect2_dropShadow_16390_68019"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 18 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 14 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_16390_68019",
						result: "effect3_dropShadow_16390_68019"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_16390_68019",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect4_innerShadow_16390_68019"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_16390_68019",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(92 92) rotate(90) scale(92)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_16390_68019",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(91.5 92) rotate(90) scale(65 64.5)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgUpdateStory);
export default ForwardRef;
